module.exports = __webpack_public_path__ + "img/operationCapacity7.be7e3de4.png";